import React from 'react'
import { FaPlus } from 'react-icons/fa'
import { Link } from 'react-router-dom'

const AddItem = ({ redirect }) => {
  return (
    <div className="bg-gray-100 sm:w-[90%] mx-auto mt-5 rounded-lg shadow-inner">
      <div className="bg-white rounded-md shadow-md p-6 flex justify-center">
        <Link
          to={redirect}
          className="text-xl p-2 rounded-full bg-[#ff7010] text-white"
          title="Add New"
        >
          <FaPlus />
        </Link>
      </div>
    </div>
  )
}

export default AddItem
